import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../app.config";
var GoogleMapsService = /** @class */ (function () {
    function GoogleMapsService(http, config) {
        this.http = http;
        this.config = config;
    }
    GoogleMapsService.prototype.getMapsPlaceDetail = function (placeID, sessionId) {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/maps/placedetail?placeid=" + placeID + "&sessionid=" + sessionId);
    };
    GoogleMapsService.ngInjectableDef = i0.defineInjectable({ factory: function GoogleMapsService_Factory() { return new GoogleMapsService(i0.inject(i1.HttpClient), i0.inject(i2.AppConfig)); }, token: GoogleMapsService, providedIn: "root" });
    return GoogleMapsService;
}());
export { GoogleMapsService };
